/* eslint-disable formatjs/no-literal-string-in-jsx */
import PageHeader from '@atlaskit/page-header';
import { SkeletonContext, SkeletonItem } from '@databases/skeleton';
import { range } from 'lodash-es';
import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

import FieldNameContainer from '../database-field/field-name/FieldNameContainer';
import {
  FieldNameInlineContainer,
  FieldNameWithActionsContainer,
} from '../database-field/field-name/FieldNameWithActions';
import { StyledInlineEditWrapper } from '../database-value/DatabaseValueInlineEdit';
import { DatabaseValueViewContainer } from '../database-value/utils';

import { Container as DatabaseEntryContainer, Table } from './DatabaseEntry';

export const DatabaseEntryMacroContainer = styled.div``;

export const ToolbarSkeleton = styled.div`
  display: flex;
  justify-content: flex-end;
  padding-bottom: 10px;
`;

const DatabaseEntrySkeletonWrapper = styled(DatabaseEntryMacroContainer)`
  * {
    user-select: none;
    border: none;
    outline: none;
    cursor: default;
  }

  ${Table} {
    grid-template-columns: 260px 1fr;
  }

  .add-field {
    grid-column: 1 / -1;
    padding: 10px 8px;
  }
`;

interface DatabaseEntrySkeletonProps {
  showBreadCrumbs?: boolean;
}

const DatabaseEntrySkeleton: FunctionComponent<DatabaseEntrySkeletonProps> = ({
  showBreadCrumbs = false,
}) => {
  return (
    <SkeletonContext isEnabled>
      <DatabaseEntrySkeletonWrapper>
        {showBreadCrumbs ? (
          <>
            <PageHeader>
              <div style={{ height: 4 }} />
              <div style={{ display: 'flex' }}>
                <SkeletonItem>New Entry Name</SkeletonItem>
                <div style={{ flexGrow: 1 }} />
                <SkeletonItem isButton width={30} height={30} style={{ height: 40 }}>
                  More
                </SkeletonItem>
              </div>
            </PageHeader>
          </>
        ) : (
          <ToolbarSkeleton>
            <h2>
              <SkeletonItem>New Database Name</SkeletonItem>
            </h2>
            <div style={{ flexGrow: 1 }} />
            <SkeletonItem isButton width={30} height={30} style={{ height: 40 }}>
              More
            </SkeletonItem>
          </ToolbarSkeleton>
        )}

        <DatabaseEntryContainer>
          <Table>
            <tbody>
              {range(5).map((i) => {
                const fieldName = i % 2 === 1 ? 'Long field name' : 'Short field';
                const databaseValue =
                  i % 2 === 0
                    ? 'Very very very very very long value'
                    : 'Shorter entry value';
                return (
                  <tr key={i}>
                    <th>
                      <FieldNameWithActionsContainer>
                        <FieldNameInlineContainer>
                          <FieldNameContainer>
                            <SkeletonItem hasIcon>{fieldName}</SkeletonItem>
                          </FieldNameContainer>
                        </FieldNameInlineContainer>
                      </FieldNameWithActionsContainer>
                    </th>
                    <td>
                      <StyledInlineEditWrapper>
                        <DatabaseValueViewContainer>
                          <SkeletonItem>{databaseValue}</SkeletonItem>
                        </DatabaseValueViewContainer>
                      </StyledInlineEditWrapper>
                    </td>
                  </tr>
                );
              })}
            </tbody>
            <tfoot>
              <tr>
                <td colSpan={2} className="add-field">
                  <SkeletonItem hasIcon maxWidth={80}>
                    Add field
                  </SkeletonItem>
                </td>
              </tr>
            </tfoot>
          </Table>
        </DatabaseEntryContainer>
      </DatabaseEntrySkeletonWrapper>
    </SkeletonContext>
  );
};

export default DatabaseEntrySkeleton;
